import {
  INDUSTRY_ICON,
  MEASUREMENT_REGULATION_ICON,
  SERVICE_ICON,
  ENERGY_ICON,
  ASRTP_ICON,
  KEY_ICON,
} from "@/components/icons/icons";
import { ImagesEnum } from "@/model/enum/ImagesEnum";
import { RoutesEnum } from "@/model/enum/RoutesEnum";
import { SolutionTypeEnum } from "@/model/enum/SolutionTypeEnum";

export const priemysel = {
  nameKey: "solutions:priemysel.name",
  descriptionKey: "solutions:priemysel.description",
  href: `${RoutesEnum.SOLUTIONS}/${SolutionTypeEnum.PRIEMYSEL}`,
  icon: INDUSTRY_ICON,
  imageUrl: ImagesEnum.PRIEMYSEL,
  type: SolutionTypeEnum.PRIEMYSEL,

  detailsPageHeroDescriptionKey:
    "solutions:priemysel.detailsPageHeroDescription",
  experienceKey: "solutions:priemysel.experience",
  experiencePointsKey: "solutions:priemysel.experiencePoints",
  ourFocusDescriptionKey: "solutions:priemysel.ourFocusDescription",
  ourFocusPoints: [
    {
      icon: MEASUREMENT_REGULATION_ICON,
      titleKey: "solutions:priemysel.ourFocusPoints.0.title",
      descriptionKey: "solutions:priemysel.ourFocusPoints.0.description",
    },
    {
      icon: ENERGY_ICON,
      titleKey: "solutions:priemysel.ourFocusPoints.1.title",
      descriptionKey: "solutions:priemysel.ourFocusPoints.1.description",
    },
    {
      icon: SERVICE_ICON,
      titleKey: "solutions:priemysel.ourFocusPoints.2.title",
      descriptionKey: "solutions:priemysel.ourFocusPoints.2.description",
    },
    {
      icon: INDUSTRY_ICON,
      titleKey: "solutions:priemysel.ourFocusPoints.3.title",
      descriptionKey: "solutions:priemysel.ourFocusPoints.3.description",
    },
    {
      icon: ASRTP_ICON,
      titleKey: "solutions:priemysel.ourFocusPoints.4.title",
      descriptionKey: "solutions:priemysel.ourFocusPoints.4.description",
    },
    {
      icon: KEY_ICON,
      titleKey: "solutions:priemysel.ourFocusPoints.5.title",
      descriptionKey: "solutions:priemysel.ourFocusPoints.5.description",
    },
  ],
  sectionWithImage: null,
  section: [
    {
      subtitleKey: "solutions:priemysel.section.0.subtitle",
      titleKey: "solutions:priemysel.section.0.title",
      descriptionKey: "solutions:priemysel.section.0.description",
      sectionPointsKey: "solutions:priemysel.section.0.sectionPoints",
    },
  ],
  solutionsForTopic: [
    {
      titleKey: "solutions:priemysel.solutionsForTopic.0.title",
      descriptionKey: "solutions:priemysel.solutionsForTopic.0.description",
      pointsKey: "solutions:priemysel.solutionsForTopic.0.points",
    },
    {
      titleKey: "solutions:priemysel.solutionsForTopic.1.title",
      descriptionKey: "solutions:priemysel.solutionsForTopic.1.description",
      pointsKey: "solutions:priemysel.solutionsForTopic.1.points",
    },
  ],
};
